export default __webpack_public_path__ + "static/media/f-05.4a8eece6.jpg";